var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenEnergyMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,2c-5.0234375,0-22.1923828,0.7783203-32.2070312,10.7929688C10.0605469,15.5253906,8,20.34375,8,24 c0,3.9373779,1.4276733,7.6472168,4.013916,10.5720215l-8.7209473,8.7209473l1.4140625,1.4140625l8.7209473-8.7209473 C16.3527222,38.5722656,20.0626221,40,24,40c3.9560547,0,8.2509766-1.8369141,11.2070312-4.7929688 C45.2216797,25.1923828,46,8.0234375,46,3C46,2.4472656,45.5527344,2,45,2z M33.7929688,33.7929688 C31.1982422,36.3876953,27.4453125,38,24,38c-3.4031982,0-6.6133423-1.2175293-9.157959-3.4279785l11.8649902-11.8649902 l-1.4140625-1.4140625L13.4279785,33.157959C11.2175293,30.6132812,10,27.4031982,10,24 c0-3.1318359,1.8476562-7.4335938,4.2070312-9.7929688C23.0996094,5.3144531,38.1835938,4.1220703,43.9902344,4.0097656 C43.8779297,9.8164062,42.6855469,24.9003906,33.7929688,33.7929688z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEnergyMedium);
export default __webpack_public_path__ + "static/media/green-energy--medium.ebbb33bfa43932a6d2a46b3439517753.svg";
export { ForwardRef as ReactComponent };